/**
 * Calculates a recording duration in seconds
 *
 * @param {Number} startedAt - timestamp the recordings starts at
 * @param {Number} stoppedAt - timestamp the recordings stops at
 * @returns {Number} duration in seconds
 */
export default function roundRecordingDuration(startedAt, stoppedAt) {
  return Number(((stoppedAt - startedAt) * 0.001).toFixed(2));
}
